export const renderSymbol = (symbolName) => {
    let symbol = '■';

    if (symbolName) {
        switch (symbolName) {
            case 'circle':
                symbol = '●';
                break;
            case 'diamond':
                symbol = '♦';
                break;
            case 'square':
                symbol = '■';
                break;
            case 'triangle':
                symbol = '▲';
                break;
            case 'triangle-down':
                symbol = '▼';
                break;
            default:
                symbol = '■';
        }
    }
    return symbol;
};
